// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"be14c44e","108":"1f263e53","487":"4535aa0d","939":"8a447d7c","947":"ce2aac13","988":"c87bac38"}[chunkId] + ".chunk.js";
};